const ArticlesComponent = {
    data() {
        return {
            articles: [],
            loading: false,

            limit: 8,
            currentPage: 1,
            pagesCount: 1,
            rowsCount: 0,
        };
    },

    methods: {
        async getArticles(page = 1) {
            this.loading = true;
            this.currentPage = page;
            this.pagesCount = 1;

            try {
                const response = await fetch(window.appConfig.routes.getArticles, {
                    method: 'post',
                    headers: {
                        'X-CSRF-TOKEN': window.appConfig.csrfToken,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        limit: this.limit,
                        page: page
                    })
                });

                const data = await response.json();

                if (data?.detail?.invalid_page) {
                    this.goToPage(data.detail.go_to_page);
                    return;
                }

                this.articles = data.data ?? [];
                this.pagesCount = data.detail?.pages_count ?? 1;
                this.rowsCount = data.detail?.rows_count ?? 0;

            } catch (error) {
                console.error(error);
                this.articles = [];
            } finally {
                this.loading = false;
            }
        },

        goToPage(page) {
            if (page === this.currentPage || this.loading) return;
            this.getArticles(page);
        },

        formatViews(views) {
            const lastDigit = views % 10;
            const lastTwoDigits = views % 100;

            if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
                return `${views} просмотров`;
            }

            if (lastDigit === 1) {
                return `${views} просмотр`;
            }

            if (lastDigit >= 2 && lastDigit <= 4) {
                return `${views} просмотра`;
            }

            return `${views} просмотров`;
        },

        formatDate(dateString) {
            const date = new Date(dateString);
            const months = [
                'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
                'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
            ];

            const day = date.getDate().toString().padStart(2, '0');
            const month = months[date.getMonth()];
            const year = date.getFullYear();

            return `${day} ${month} ${year}`;
        }
    },

    mounted() {
        this.getArticles(1);
    },

    computed: {
        showLoading() {
            return this.loading;
        },

        showContent() {
            return !this.loading && this.articles.length > 0;
        },

        paginationPages() {
            return globalState.paginationPages( this.pagesCount, this.currentPage )
        }
    }
};

window.ArticlesComponent = ArticlesComponent;